interface PercentileResult {
  min: number | null
  max: number | null
}

/**
 * Gets the min and max values at the given percentile from an array of numbers.
 * @param arr - Array of numbers
 * @param percentile - Percentile (0-100)
 * @returns Object with min and max values at the given percentile
 */
const getPercentile = (
  arr: number[],
  percentile: number = 5
): PercentileResult => {
  if (arr.length === 0) return { min: null, max: null }
  if (percentile < 0 || percentile > 100)
    throw new Error('Percentile must be between 0 and 100')

  const sortedArr = [...arr].filter(v => !Number.isNaN(v)).sort((a, b) => a - b)

  const lastIndex = sortedArr.length - 1
  const minPosition = Math.min(
    Math.floor((percentile / 100) * sortedArr.length),
    lastIndex
  )
  const maxPosition = Math.min(
    Math.floor(((100 - percentile) / 100) * sortedArr.length),
    lastIndex
  )

  return {
    min: sortedArr[Math.min(minPosition, maxPosition)],
    max: sortedArr[Math.max(minPosition, maxPosition)]
  }
}

export default getPercentile
